import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

const stringifyParams = params =>
	qs.stringify(params, { encodeValuesOnly: true });

// Get Scheduled Activity List with Query (for remote ODataGrid)
export const getScheduledActivityListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_SCHEDULED_ACTIVITIES}?${stringifyParams(params)}`
	);
};

// Get Single Scheduled Activity
export const getScheduledActivityApi = id => {
	return apiClient.get(`${WATER_RIGHTS_BASE}${url.GET_SCHEDULED_ACTIVITY}${id}`);
};

// Update Scheduled Activity (PUT)
export const updateScheduledActivityApi = (id, data) => {
	return apiClient.put(`${WATER_RIGHTS_BASE}${url.PUT_SCHEDULED_ACTIVITY}${id}`, data);
};

// Delete Scheduled Activity
export const deleteScheduledActivityApi = id => {
	return apiClient.delete(`${WATER_RIGHTS_BASE}${url.DELETE_SCHEDULED_ACTIVITY}${id}`);
};

// Download Scheduled Activity File metadata
export const downloadScheduledActivityFileApi = id => {
	return apiClient.get(`${WATER_RIGHTS_BASE}${url.DOWNLOAD_SCHEDULED_ACTIVITY_FILE}${id}`);
};
